import { Row, Space, Switch } from "antd";
import { Paragraph } from "./Text";
import { InfoTooltip } from "./InfoTooltip";

export function NewFindingsToggle({ onChange, tooltipText }) {
  return (
    <Row style={{ width: "100%", padding: "8px 0" }} align="middle">
      <Space size={8}>
        <Switch size="small" onChange={onChange} />
        <Paragraph level={3} weight={500}>
          Show new findings only
        </Paragraph>
        <InfoTooltip text={tooltipText} placement="right" size={14} />
      </Space>
    </Row>
  );
}
